import { Modal } from "react-bootstrap";
import React, { useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SocialUpdate, ProfileGet } from "../../apis/api/ProfileApi";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const EditSocialMediaModal = ({ show, handleClose, company_data }) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const userId = Cookies.get("userID");

  const company_id = Cookies.get("company_id");
  // Prefill form fields when company_data changes
  useEffect(() => {
    if (company_data) {
      setValue("facebook", company_data.facebook_url || "");
      setValue("twitter", company_data.twitter_url || "");
      setValue("linkedin", company_data.linkedIn_url || "");
      setValue("instagram", company_data.instagram_url || "");
      setValue("website", company_data.website || "");
    }
  }, [company_data, setValue]);

  const onSubmit = async (formData) => {
    const postdata = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      postdata.append(key, value);
    });

    postdata.append("company_id", company_id);

    const response = await dispatch(SocialUpdate(postdata));

    if (response.payload.status == "success") {
      const profile_update = await dispatch(ProfileGet({ userId, company_id }));
      if (profile_update.payload.status == "success") {
        reset();
        handleClose();
        toast.success("Social Media Detail Updated Successfully!");
      } else {
        reset();
        handleClose();
        toast.error("Error");
      }
    }
  };

  return (
    <Modal show={show} size="lg" centered>
      <Modal.Header closeButton onHide={handleClose}>
        <Modal.Title>Edit Social Media Links</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="p-4 border rounded shadow bg-light"
        >
          <div className="row mb-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label>Website</Form.Label>
                <Form.Control
                  type="url"
                  {...register("website", {
                    pattern: {
                      value:
                        /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}.*$/i,
                      message: "Enter a valid website URL",
                    },
                  })}
                  placeholder="Enter website URL..."
                />
                {errors.website && (
                  <span className="text-danger">{errors.website.message}</span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label>Facebook</Form.Label>
                <Form.Control
                  type="url"
                  {...register("facebook", {
                    pattern: {
                      value: /^(https?:\/\/)?(www\.)?facebook\.com\/([A-Za-z0-9\.]+|profile\.php\?id=\d+)\/?$/i,
                      message: "Enter a valid Facebook profile or page URL",
                    },
                  })}
                  placeholder="Enter Facebook profile URL..."
                />
                {errors.facebook && (
                  <span className="text-danger">{errors.facebook.message}</span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label>Twitter</Form.Label>
                <Form.Control
                  type="url"
                  {...register("twitter", {
                    pattern: {
                      value: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\/[A-Za-z0-9_]+\/?$/i,
                      message: "Enter a valid Twitter/X profile URL",
                    },
                  })}
                  placeholder="Enter Twitter profile URL..."
                />
                {errors.twitter && (
                  <span className="text-danger">{errors.twitter.message}</span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control
                  type="url"
                  {...register("linkedin", {
                    pattern: {
                      value: /^(https?:\/\/)?([\w]+\.)?linkedin\.com\/.*/i,
                      message: "Enter a valid LinkedIn URL",
                    },
                  })}
                  placeholder="Enter LinkedIn profile URL..."
                />
                {errors.linkedin && (
                  <span className="text-danger">{errors.linkedin.message}</span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <Form.Group>
                <Form.Label>Instagram</Form.Label>
                <Form.Control
                  type="url"
                  {...register("instagram", {
                    pattern: {
                      value: /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9._]+\/?$/i,
                      message: "Enter a valid Instagram profile URL",
                    },
                  })}
                  placeholder="Enter Instagram profile URL..."
                />
                {errors.instagram && (
                  <span className="text-danger">
                    {errors.instagram.message}
                  </span>
                )}
              </Form.Group>
            </div>
          </div>

          <Modal.Footer>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditSocialMediaModal;
